const alarmsFiltersData = {
    period: [
        { value: 0, label: 'Last year' },
        { value: 1, label: 'Last 50 snapshots' },
        { value: 2, label: 'Last week' },
    ],
    ut: [
        { value: 0, code: '', label: 'All' },
        { value: 1, code: '36', label: 'UT-36' }
    ],
    groupid: [
        { value: 0, label: 'All' },
        { value: 1, code: 'ACR1', label: 'ACR1' },
        { value: 2, code: 'ACR2', label: 'ACR2' }
    ],
    triggerid: [
        { value: 0, label: 'All' },
        { value: 1, code: '1', label: '1' },
        { value: 2, code: '6', label: '6' },
        { value: 3, code: '7', label: '7' },
        { value: 4, code: '8', label: '8' },
        { value: 5, code: '9', label: '9' }
    ],
}

export default alarmsFiltersData



// WEBPACK FOOTER //
// ./src/data/alarmsFiltersData.js